<template>
  <div id="pagination-sidebar">
    <!-- {{ pageReadyIndex }} -->
    <div
      class="pagination-item"
      :class="{ selected: isSelected(index) }"
      v-for="(page, index) in pages"
      :key="index + '-visual-pagination'"
      ref="paginationItems"
    >
      <article
        class="project-page"
        :class="'template-' + templateName"
        :key="index + '-page'"
        @click="changePage(index)"
      >
        <component
          :is="getPageComponentName(page.type)"
          :page="page"
          :pageId="index"
          :readOnly="true"
        >
        </component>
      </article>

      <span class="item-index" v-if="showCoverAndIndex ? index - 1 > 0 : true">
        {{ showCoverAndIndex ? index - 1 : index + 1 }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import Cover from "@/components/Projects/Playbooks/Cover/Cover.vue";
import Index from "@/components/Projects/Playbooks/Index/Index.vue";

import Hero from "@/components/Projects/Playbooks/Hero/Hero.vue";
import Designs from "@/components/Projects/Playbooks/Designs/Designs.vue";
import Sublimated from "@/components/Projects/Playbooks/Products/Sublimated.vue";
import Stock from "@/components/Projects/Playbooks/Products/Stock.vue";
import Outfit from "@/components/Projects/Playbooks/Outfit/Outfit.vue";
import Extras from "@/components/Projects/Playbooks/Extras/Extras.vue";

import SnapsheetPage from "@/components/Projects/Snapsheets/SnapsheetPage.vue";

import BackCover from "@/components/Projects/Playbooks/BackCover/BackCover.vue";

export default {
  name: "PaginationSidebar",
  computed: {
    ...mapState(["loading", "displayingIndex"]),

    ...mapState("playbook", {
      template: "template",
      showCoverAndIndex: "showCoverAndIndex",
    }),

    ...mapGetters("playbook", {
      playbookPages: "filteredPages",
    }),

    ...mapState("snapsheet", {
      snapsheetPages: (state) => state.pages,
    }),
    ...mapState("project", ["actualPage"]),

    ...mapGetters("project", ["isPlaybook"]),

    pages() {
      return this.isPlaybook ? this.playbookPages : this.snapsheetPages;
    },

    templateName() {
      return this.template?.toLowerCase();
    },
  },
  methods: {
    ...mapActions("project", ["setPage"]),

    changePage(number) {
      this.setPage(number + 1);
    },

    getPageComponentName(pageType) {
      if (pageType?.toLowerCase() == "five day") {
        return "Sublimated";
      } else {
        return pageType;
      }
    },

    isSelected(pageIndex) {
      return this.actualPage == pageIndex + 1;
    },
  },

  components: {
    Cover,
    Index,
    Hero,
    Designs,
    BackCover,
    Stock,
    Sublimated,
    Outfit,
    Extras,
    Snapsheet: SnapsheetPage,
  },

  watch: {
    actualPage() {
      this.$nextTick(() => {
        this.$refs.paginationItems?.forEach((item) => {
          if (item?.classList.contains("selected")) {
            item.scrollIntoView({
              block: "end",
              inline: "nearest",
              behavior: "smooth",
            });
          }
        });
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.paginationItems?.forEach((item) => {
        if (item?.classList.contains("selected")) {
          item.scrollIntoView({
            block: "end",
            inline: "nearest",
            behavior: "smooth",
          });
        }
      });
    });
  },
};
</script>

<style lang="scss">
#app {
  #pagination-sidebar {
    width: 145px;
    padding: 0 !important;
    height: 93vh;
    overflow-y: scroll;
    position: fixed;
    right: 0;
    top: 65px;
    z-index: 10;
    .pagination-item {
      width: 100px;
      height: 11em !important;
      margin: 1em 5px;
      background: #ffffff;
      box-shadow: 0 0 6px 2px rgba(40, 42, 48, 0.08);
      border-radius: 0.91936px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      .item-index {
        font-size: 1rem;
        color: white;
        background: $grey-dark;
        position: absolute;
        pointer-events: none;
        top: 0;
        right: 0;
        padding: 0.5em 1em;
        border-bottom-left-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
      }

      &.selected {
        .item-index {
          background: $snapsheetColor;
        }
      }
      .project-page {
        height: 100%;
        font-size: 3px;
        line-height: 2px;
        .page {
          height: 100%;
          overflow: hidden;
          .product-info {
            max-height: 50%;
            overflow-y: clip;
            li.table-item-small {
              height: 0.5em;
            }
          }
          .product-description {
            //display: none;
            ul {
              list-style: none;
            }
          }
          .cover-heroes-row {
            height: 100% !important;
          }

          h2.title {
            font-size: 2em !important;
            margin-right: auto;
            margin-left: 0;
          }

          .designs-page {
            padding-left: 1.25em;
            padding-right: 1.75em;
            padding-top: 1em;
            padding-bottom: 1em;

            .hero-design {
              align-items: center;
              .product-preview {
                height: auto;
              }
            }

            .other-designs {
              column-gap: 0.1em;
            }
          }

          #product-info {
            .branding {
              img {
                max-width: 100% !important;
              }
            }
            .product-info {
              max-height: 100%;
              .product-description {
                margin-bottom: 0.1em;
                font-size: 1.25em;
                line-height: 1em;
              }
              .grid-container {
                li {
                  height: 2em;
                }
              }
            }
            .info-text p {
              line-height: 1.25em;
              font-size: 1em;
            }
          }
          .table-of-contents-container {
            justify-content: space-evenly;

            .footer-section {
              height: fit-content;
              .branding-item {
                line-height: 1.5em;
                font-size: 0.75em;

                .cover-branding-img {
                  max-width: 3.5em;
                }
              }
            }
          }
        }
      }
      &:hover {
        box-shadow: 0 0 6px 2px rgba(40, 42, 48, 0.5);
      }

      ::v-deep img.d-img {
        width: 1em !important;
        margin-right: 1em !important;
        max-height: 2em !important;
        max-width: 2em !important;
      }
    }

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
}
</style>
